"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderPropSticky = void 0;
const render_props_version_1 = __importDefault(require("./render-props-version"));
exports.RenderPropSticky = render_props_version_1.default;
const basic_version_1 = __importDefault(require("./basic-version"));
exports.default = basic_version_1.default;